import React from 'react'

const ButtonDropdowns = () => (
  <section><a className="anchor"id="button-dropdowns"></a>

    <h2>Button Dropdowns</h2>
    <p>A dropdown is a toggleable menu that allows the user to choose one value from a predefined list.</p>

    <div>

      <div className="dropdown push-quarter--bottom push-quarter--right">
        <button className="btn" type="button" data-toggle="dropdown">Dropdown Example <span className="fa fa-caret"></span></button>
        <ul className="dropdown-menu">
          <li><a href="#">HTML</a></li>
          <li><a href="#">CSS</a></li>
          <li><a href="#">JavaScript</a></li>
        </ul>
      </div>

      <div className="dropdown push-quarter--bottom push-quarter--right">
        <button className="btn btn--positive" type="button" data-toggle="dropdown">Dropdown Example <span className="fa fa-caret"></span></button>
        <ul className="dropdown-menu dropdown-menu--positive">
          <li><a href="#">HTML</a></li>
          <li><a href="#">CSS</a></li>
          <li><a href="#">JavaScript</a></li>
        </ul>
      </div>

      <div className="dropdown push-quarter--bottom push-quarter--right">
        <button className="btn btn--negative" type="button" data-toggle="dropdown">Dropdown Example <span className="fa fa-caret"></span></button>
        <ul className="dropdown-menu dropdown-menu--negative">
          <li><a href="#">HTML</a></li>
          <li><a href="#">CSS</a></li>
          <li><a href="#">JavaScript</a></li>
        </ul>
      </div>

      <div className="dropdown push-quarter--bottom push-quarter--right">
        <button className="btn btn--outline" type="button" data-toggle="dropdown">Dropdown Example <span className="fa fa-caret"></span></button>
        <ul className="dropdown-menu">
          <li><a href="#">HTML</a></li>
          <li><a href="#">CSS</a></li>
          <li><a href="#">JavaScript</a></li>
        </ul>
      </div>

      <div className="dropdown push-quarter--bottom push-quarter--right">
        <button className="btn btn--positive btn--outline" type="button" data-toggle="dropdown">Dropdown Example <span className="fa fa-caret"></span></button>
        <ul className="dropdown-menu dropdown-menu--positive">
          <li><a href="#">HTML</a></li>
          <li><a href="#">CSS</a></li>
          <li><a href="#">JavaScript</a></li>
        </ul>
      </div>

      <div className="dropdown push-quarter--bottom push-quarter--right">
        <button className="btn btn--negative btn--outline" type="button" data-toggle="dropdown">Dropdown Example <span className="fa fa-caret"></span></button>
        <ul className="dropdown-menu dropdown-menu--negative">
          <li><a href="#">HTML</a></li>
          <li><a href="#">CSS</a></li>
          <li><a href="#">JavaScript</a></li>
        </ul>
      </div>

      <div className="dropdown push-quarter--bottom push-quarter--right">
        <button className="btn btn--transparent" type="button" data-toggle="dropdown">Dropdown Example <span className="fa fa-caret"></span></button>
        <ul className="dropdown-menu">
          <li><a href="#">HTML</a></li>
          <li><a href="#">CSS</a></li>
          <li><a href="#">JavaScript</a></li>
        </ul>
      </div>

    </div>

    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
    <pre className="hide-code"><code className="language-html">{`<!-- // primary (default) -->
<div class="dropdown push-quarter--bottom push-quarter--right">
  <button class="btn" type="button" data-toggle="dropdown">Dropdown Example <span class="fa fa-caret"></span></button>
  <ul class="dropdown-menu">
    <li><a href="#">HTML</a></li>
    <li><a href="#">CSS</a></li>
    <li><a href="#">JavaScript</a></li>
  </ul>
</div>

<!-- // positive -->
<div class="dropdown push-quarter--bottom push-quarter--right">
  <button class="btn btn--positive" type="button" data-toggle="dropdown">Dropdown Example <span class="fa fa-caret"></span></button>
  <ul class="dropdown-menu dropdown-menu--positive">
    <li><a href="#">HTML</a></li>
    <li><a href="#">CSS</a></li>
    <li><a href="#">JavaScript</a></li>
  </ul>
</div>

<!-- // negative -->
<div class="dropdown push-quarter--bottom push-quarter--right">
  <button class="btn btn--negative" type="button" data-toggle="dropdown">Dropdown Example <span class="fa fa-caret"></span></button>
  <ul class="dropdown-menu dropdown-menu--negative">
    <li><a href="#">HTML</a></li>
    <li><a href="#">CSS</a></li>
    <li><a href="#">JavaScript</a></li>
  </ul>
</div>

<!-- // primary outline -->
<div class="dropdown push-quarter--bottom push-quarter--right">
  <button class="btn btn--outline" type="button" data-toggle="dropdown">Dropdown Example <span class="fa fa-caret"></span></button>
  <ul class="dropdown-menu">
    <li><a href="#">HTML</a></li>
    <li><a href="#">CSS</a></li>
    <li><a href="#">JavaScript</a></li>
  </ul>
</div>

<!-- // positive outline -->
<div class="dropdown push-quarter--bottom push-quarter--right">
  <button class="btn btn--positive btn--outline" type="button" data-toggle="dropdown">Dropdown Example <span class="fa fa-caret"></span></button>
  <ul class="dropdown-menu dropdown-menu--positive">
    <li><a href="#">HTML</a></li>
    <li><a href="#">CSS</a></li>
    <li><a href="#">JavaScript</a></li>
  </ul>
  </div>

<!-- // negative outline -->
<div class="dropdown push-quarter--bottom push-quarter--right">
  <button class="btn btn--negative btn--outline" type="button" data-toggle="dropdown">Dropdown Example <span class="fa fa-caret"></span></button>
  <ul class="dropdown-menu dropdown-menu--negative">
    <li><a href="#">HTML</a></li>
    <li><a href="#">CSS</a></li>
    <li><a href="#">JavaScript</a></li>
  </ul>
</div>

<!-- // transparent -->
<div class="dropdown push-quarter--bottom push-quarter--right">
  <button class="btn btn--transparent" type="button" data-toggle="dropdown">Dropdown Example <span class="fa fa-caret"></span></button>
  <ul class="dropdown-menu">
    <li><a href="#">HTML</a></li>
    <li><a href="#">CSS</a></li>
    <li><a href="#">JavaScript</a></li>
  </ul>
</div>`}</code></pre>

    <br/>

    <p>This is a javascript enabled component. You must initialize it using the following snippet:</p>

    <pre><code className="language-javascript">{`commonUI.initializeDropdown();`}</code></pre>

    <br/>

    <p>Dropdown menus can be changed to expand upwards (instead of downwards) by adding the "data-direction" attribute to the parent element set to "up".</p>

    <div className="dropdown" data-direction="up">
      <button className="btn btn--primary" type="button" data-toggle="dropdown">Dropdown Example <span className="fa fa-caret"></span></button>
      <ul className="dropdown-menu">
        <li><a href="#">HTML</a></li>
        <li><a href="#">CSS</a></li>
        <li><a href="#">JavaScript</a></li>
      </ul>
    </div>

    <br/><br/>

    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
    <pre className="hide-code"><code className="language-html">{`<div class="dropdown" data-direction="up">
  <button class="btn btn--primary" type="button" data-toggle="dropdown">Dropdown Example <span class="fa fa-caret"></span></button>
  <ul class="dropdown-menu">
    <li><a href="#">HTML</a></li>
    <li><a href="#">CSS</a></li>
    <li><a href="#">JavaScript</a></li>
  </ul>
</div>
`}</code></pre>

    <h3>Dropdown Groups</h3>

    <p>
      Dropdown menus can be organised into groups. Headings can be added to each group along with dividers, giving more control to the separation of content.
      When using a tags for menu items, add class 'disabled' to disable the link functionality and apply disabled style
    </p>

    <div>
      <div className="dropdown">
        <button className="btn" type="button" data-toggle="dropdown">Group Dropdown Example <span className="fa fa-caret" /></button>
        <ul className="dropdown-menu">
          <li>
            <ul>
              <div className="dropdown-title">Group Heading 1</div>
              <li><a href="#">HTML</a></li>
              <li><a href="#" className="disabled">CSS</a></li>
              <li><a href="#">JavaScript</a></li>
            </ul>
          </li>
          <div className="dropdown-divider" />
          <li>
            <ul>
              <div className="dropdown-title">Group Heading 2</div>
              <li><a href="#">HTML</a></li>
              <li><a href="#">CSS</a></li>
              <li><a href="#">JavaScript</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
    <pre className="hide-code"><code className="language-html">{`
      <div class="dropdown">
        <button class="btn" type="button" data-toggle="dropdown">Group Dropdown Example <span class="fa fa-caret" /></button>
        <ul class="dropdown-menu">
          <li>
            <ul>
              <div class="dropdown-title">Group Heading 1</div>
              <li><a href="#">HTML</a></li>
              <li><a href="#" class="disabled">CSS</a></li>
              <li><a href="#">JavaScript</a></li>
            </ul>
          </li>
          <div class="dropdown-divider" />
          <li>
            <ul>
              <div class="dropdown-title">Group Heading 2</div>
              <li><a href="#">HTML</a></li>
              <li><a href="#">CSS</a></li>
              <li><a href="#">JavaScript</a></li>
            </ul>
          </li>
        </ul>
      </div>
    `}</code></pre>

    <br/>
    <p>Buttons can be used as dropdown items for more control over functionality (i.e. the 'disabled' property as shown below).</p>

    <div>
      <div className="dropdown">
        <button className="btn btn--primary" type="button" data-toggle="dropdown">Disabled Dropdown Example <span className="fa fa-caret" /></button>
        <ul className="dropdown-menu">
          <li>
            <ul>
              <div className="dropdown-title">Enabled links</div>
              <li><button>HTML</button></li>
              <li><button>CSS</button></li>
              <li><button>JavaScript</button></li>
            </ul>
          </li>
          <div className="dropdown-divider" />
          <li>
            <ul>
              <div className="dropdown-title">Disabled Buttons</div>
              <li><button disabled>HTML</button></li>
              <li><button disabled>CSS</button></li>
              <li><button disabled>JavaScript</button></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
    <pre className="hide-code"><code className="language-html">{`
      <div class="dropdown">
        <button class="btn btn--primary" type="button" data-toggle="dropdown">Disabled Dropdown Example <span className="fa fa-caret" /></button>
        <ul class="dropdown-menu">
          <li>
            <ul>
              <div class="dropdown-title">Enabled links</div>
              <li><button>HTML</button></li>
              <li><button>CSS</button></li>
              <li><button>JavaScript</button></li>
            </ul>
          </li>
          <div class="dropdown-divider" />
          <li>
            <ul>
              <div class="dropdown-title">Disabled Buttons</div>
              <li><button disabled>HTML</button></li>
              <li><button disabled>CSS</button></li>
              <li><button disabled>JavaScript</button></li>
            </ul>
          </li>
        </ul>
      </div>
    `}</code></pre>

  <br/><br/>

  <hr/>
</section>
)

export default ButtonDropdowns



// WEBPACK FOOTER //
// ./styleguide/components/sections/ButtonDropdowns.js